import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Console } from 'console';

@Component({
  selector: 'app-create-product-view-dialog',
  templateUrl: './create-product-view-dialog.component.html',
  styleUrls: ['./create-product-view-dialog.component.scss']
})
export class CreateProductViewDialogComponent {
  product = [];
  hasFixedAsset: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<CreateProductViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('VIEW',this.data);
    if (this.data?.productList?.length > 0) {
      this.hasFixedAsset = this.data.productList.some(p =>
        p.details.some(d => d.item_service_type === 'Fixed Asset')
      );
    }
  }

  getProductTypeName(product: any): string {
    if (!product) return '';
    if(!product.type){
      return product.name;
    }else{
      if (product.type === 'SKU') {
        return product.sku_name;
      } else if (product.type === 'Service') {
        return product.service_name;
      }
    }
    return '';
  }

  calculateDiscount(qty: number, unitPrice: number, discount: number, incentive: number = 0): number {
    const totalPrice = (qty || 0) * (unitPrice || 0);
    const finalPrice = totalPrice - (discount || 0) + (incentive || 0);
    return finalPrice;
  }
  getGroupedLedgers(): { ledger_id: number | null, ledger_name: string, totalDiscountedAmount: number }[] {
    const ledgerMap = new Map<number | string, { ledger_id: number | null, ledger_name: string, totalDiscountedAmount: number }>();
    for (const entry of this.data.productEntries) {
      const voucher = this.data.voucher;
      const type = entry.productType?.type;
      let ledgerId: number | null = null;
      let ledgerName = 'No ledger found';
      let match: any;
  
      if (voucher === 'Purchase' && type === 'SKU') {
        match = entry.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Purchase');
        ledgerName = match?.dr_ledger_name ?? 'No Purchase Sku ledger found';
        ledgerId = match?.dr_ledger ?? null;
      } else if (voucher === 'Purchase' && type === 'Service') {
        match = entry.productType?.service_ledgr_map?.[0];
        ledgerName = match?.ledger?.ledger_name ?? 'No Purchase Service Ledger found';
        ledgerId = match?.ledger?.id ?? null;
      }
      if (voucher === 'Sales' && type === 'SKU') {
        match = entry.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Sales');
        ledgerName = match?.cr_ledger_name ?? 'No Sales Sku ledger found';
        ledgerId = match?.cr_ledger ?? null;
      }else if (voucher === 'Sales' && type === 'Service') {
        match = entry.productType?.service_ledgr_map?.[0];
        ledgerName = match?.ledger?.ledger_name ?? 'No Sales Service Ledger found';
        ledgerId = match?.ledger?.id ?? null;
      }
      const qty = entry.qty ?? 0;
      const unitPrice = entry.unitPrice ?? 0;
      const discount = entry.discount ?? 0;
      const baseAmount = qty * unitPrice;
      const discountedAmount = baseAmount - (baseAmount * discount / 100);
      const key = ledgerId ?? 'null';
      if (ledgerMap.has(key)) {
        ledgerMap.get(key)!.totalDiscountedAmount += discountedAmount;
      } else {
        ledgerMap.set(key, {
          ledger_id: ledgerId,
          ledger_name: ledgerName,
          totalDiscountedAmount: discountedAmount
        });
      }
    }
  
    return Array.from(ledgerMap.values());
  }

  calculateGstAmount(product: any, gst_percentage: number): number {
    let discountedPrice = 0;
    if (this.data.InvoiceType) {
      discountedPrice = Number(product.change_value) || 0;
    } else {
      discountedPrice = this.calculateDiscount(product.qty, product.unitPrice, product.discount, product.incentive);
    }
   //const discountedPrice = this.calculateDiscount(product.qty, product.unitPrice, product.discount,product.incentive);
    // console.log('discountedPrice',(discountedPrice * gst_percentage) / 100);
    // console.log('gst_percentage',gst_percentage);
    return (discountedPrice * gst_percentage) / 100;
  }
  getGroupedGstDetails() {
    const groupedLedgers: { [key: string]: { ledger_name: string; totalAmount: number } } = {};
    const entries = this.data.productEntries || this.data.productDetails;
    if (!entries || !Array.isArray(entries)) {
      return [];
    }
    entries.forEach((product: any) => {
      const gstDetailsArray = this.getGstLedgerDetails(product.taxType);
      gstDetailsArray.forEach(gstDetails => {
        const gstAmount = this.calculateGstAmount(product, gstDetails.gst_percentage);
        if (groupedLedgers[gstDetails.ledger_name]) {
          groupedLedgers[gstDetails.ledger_name].totalAmount += gstAmount;
        } else {
          groupedLedgers[gstDetails.ledger_name] = {
            ledger_name: gstDetails.ledger_name,
            totalAmount: gstAmount,
          };
        }
      });
    });
    return Object.values(groupedLedgers);
  }
  
  getGstLedgerDetails(taxType: number): { ledger_name: string; gst_percentage: number }[] {
    if (!this.data.taxledger) return [];
    const gstLedger = this.data.taxledger.find((item: any) => item.global_gst_id === taxType);
    if (!gstLedger) return [];
    const requiredLedgerType = this.data.voucher === 'Purchase'||(this.data.InvoiceType === 'purchase') ? 'receivable' : 'payable';
    if (this.data.gstMatch) {
      return gstLedger.gst_ledgers
        .filter(ledger =>
          (ledger.gst_type === 'CGST' || ledger.gst_type === 'SGST') &&
          ledger.ledger_type === requiredLedgerType &&
          (ledger.branch_id == this.data.branch_id)
        )
        .map(ledger => ({
          ledger_name: ledger.ledger.ledger_name,
          gst_percentage: gstLedger.gst_percentage / 2,
        }));
    } else {
      return gstLedger.gst_ledgers
        .filter(ledger => 
          ledger.gst_type === 'IGST' && 
          ledger.ledger_type === requiredLedgerType &&
          (ledger.branch_id == this.data.branch_id)
        )
        .map(ledger => ({
          ledger_name: ledger.ledger.ledger_name,
          gst_percentage: gstLedger.gst_percentage,
        }));
    }
  }

  getTotalGstAmount(): number {
    const groupedGst = this.getGroupedGstDetails();
    return groupedGst.reduce((sum, item) => sum + item.totalAmount, 0);
  }
  getTotalRoundedAmount(): number {
    const totalAmount = this.data.totalAmount + this.data.totalGSTAmount;
    return totalAmount;
  }
  getRoundedAmountDifference(): number {
    const totalAmount = this.data.totalAmount + this.data.totalGSTAmount;
    const roundedTotal = Math.ceil(totalAmount);
    return Math.abs(roundedTotal - totalAmount);
  }

  // preparePostData() {
  //   const postData = {
  //     productEntries: this.data.productEntries.map(product => ({
  //       ledger_name: product.ledger_name,
  //       product_name: this.getProductName(product.productType),
  //       after_discount: this.calculateDiscount(product.qty, product.unitPrice, product.discount),
  //     })),
  //     uniqueLedgerEntries: this.uniqueLedgerIds().map(ledger => ({
  //       ledger_name: ledger.ledger_name,
  //       total_discounted_amount: ledger.totalDiscountedAmount,
  //     })),
  //     gstEntries: this.data.productEntries.map(product => ({
  //       ledger_name: this.getGstLedgerDetails(product.taxType).ledger_name,
  //       gst_amount: this.calculateGstAmount(product),
  //     })),
  //     vendorEntry: {
  //       vendor_name: this.data.selectedVendorLedgerName,
  //       amount: this.getTotalRoundedAmount(),
  //     },
  //     totals: {
  //       sub_total_amount: this.data.totalAmount,
  //       total_gst_amount: this.data.totalGSTAmount,
  //       total_amount: this.data.totalAmount + this.data.totalGSTAmount,
  //       rounded_off_amount: this.getRoundedAmountDifference(),
  //     },
  //   };
  //   return postData;
  // }

  // getSumByLedgerId2(ledgerId: number): number {
  //   const isPurchase = this.data.grn?.length !== 0 && this.data.voucher === 'Purchase';
  //   const isSales = this.data.voucher === 'Sales';
  //   const filteredDetails = this.data.productList
  //     .flatMap((product: any) => product.details || [])
  //     .filter((detail: any) => {
  //       const sku_maps = detail?.sku?.sku_detail_maps || [];
  //       const service_maps = detail?.service?.service_ledgr_map || [];

  //       if (detail?.item_service_type === 'SKU') {
  //         if (isPurchase) {
  //           return sku_maps.some((m: any) =>
  //             m.voucher_type === 'Purchase' && m.dr_ledger === ledgerId
  //           );
  //         } else if (isSales) {
  //           return sku_maps.some((m: any) =>
  //             m.voucher_type === 'Sales' && m.cr_ledger === ledgerId
  //           );
  //         }
  //       } else if (detail?.item_service_type === 'Service') {
  //         if (isPurchase) {
  //           return service_maps.some((m: any) =>
  //             m.voucher_type === 'Purchase' && m.dr_ledger === ledgerId
  //           );
  //         } else if (isSales) {
  //           return service_maps.some((m: any) =>
  //             m.voucher_type === 'Sales' && m.cr_ledger === ledgerId
  //           );
  //         }
  //       }
  //       return false;
  //     });
  //   const sum = filteredDetails.reduce((total: number, detail: any) => {
  //     const quantity = isPurchase
  //       ? Number(detail.receive_qty || 0)
  //       : Number(detail.send_qty || 0);
  //     const price = Number(detail.unit_price || 0);
  //     const discount = Number(detail.discount || 0);

  //     const result = this.calculateDiscount(quantity, price, discount);
  //     return total + result;
  //   }, 0);
  //   console.log(`✅ Total sum for ledgerId ${ledgerId}:`, sum);
  //   return sum;
  // }
  getSumByLedgerId2(ledgerId: number): number {

  const isPurchase = this.data.grn?.length !== 0 && this.data.voucher === 'Purchase';
  const isSales = this.data.voucher === 'Sales';

  const filteredDetails = this.data.productList
    .flatMap((product: any) => product.details || [])
    .filter((detail: any) => {

      const sectionIds = detail?.section_id
        ? detail.section_id.toString().split(',').map(Number)
        : [];

      const sku_maps = detail?.sku?.sku_detail_maps || [];
      const service_maps = detail?.service?.service_ledgr_map || [];

      if (detail?.item_service_type === 'SKU') {

        return sku_maps.some((m: any) =>
          sectionIds.includes(Number(m.section_id)) &&   // ✅ FIX
          (
            (isPurchase && m.dr_ledger === ledgerId) ||
            (isSales && m.cr_ledger === ledgerId)
          )
        );

      } else if (detail?.item_service_type === 'Service') {

        return service_maps.some((m: any) =>
          sectionIds.includes(Number(m.section_id)) &&   // ✅ FIX
          (
            (isPurchase && m.dr_ledger === ledgerId) ||
            (isSales && m.cr_ledger === ledgerId)
          )
        );
      } else if (detail?.item_service_type === 'Fixed Asset') {
        const fa_maps = detail?.fa_master || [];
        return fa_maps.some((m: any) =>
          (isPurchase && m.ledger_id === ledgerId)
        );
      }

      return false;
    });

  // ================= SUM =================
  const sum = filteredDetails.reduce((total: number, detail: any) => {

    const quantity = isPurchase
      ? Number(detail.receive_qty || 0)
      : Number(detail.send_qty || 0);

    const price = Number(detail.unit_price || 0);
    const discount = Number(detail.discount_amount || 0);
    const incentive = Number(detail.incentive_amount || 0);

    const result = this.calculateDiscount(quantity, price, discount,incentive);

    return total + result;

  }, 0);

  console.log(`✅ Total sum for ledgerId ${ledgerId}:`, sum);

  return sum;
}
  // uniqueLedgerIds2() {
  //   const details = this.data.productList.flatMap((product: any) => product.details || []);
  //   const purchaseOrders = this.data.productList.flatMap((product: any) => product.purchase_order ? [product.purchase_order] : []);
  //   const salesOrders = this.data.productList.flatMap((product: any) => product.sales_order ? [product.sales_order] : []);
  //   const isPurchase = this.data.grn?.length !== 0 && this.data.voucher === 'Purchase';
  //   const isSales = this.data.voucher === 'Sales';

  //   const uniqueIds: number[] = Array.from(
  //     new Set(
  //       details.map((detail: any) => {
  //         const sku_maps = detail?.sku?.sku_detail_maps || [];
  //         const service_maps = detail?.service?.service_ledgr_map || [];

  //         if (detail?.item_service_type === 'SKU') {
  //           if (isPurchase) {
  //             const match = sku_maps.find((m: any) =>
  //               (m.voucher_type === 'Purchase' ||
  //                 purchaseOrders.some((po: any) => po.section_id === m.section_id)) &&
  //               m.dr_ledger
  //             );
  //             return match?.dr_ledger;
  //           } else if (isSales) {
  //             const match = sku_maps.find((m: any) =>
  //               (m.voucher_type === 'Sales' ||
  //                 salesOrders.some((so: any) => so.section_id === m.section_id)) &&
  //               m.cr_ledger
  //             );
  //             return match?.cr_ledger;
  //           }
  //         }

  //         if (detail?.item_service_type === 'Service') {
  //           if (isPurchase) {
  //             const match = service_maps.find((m: any) =>
  //               (m.voucher_type === 'Purchase' ||
  //                 purchaseOrders.some((po: any) => po.section_id === m.section_id)) &&
  //               m.dr_ledger
  //             );
  //             return match?.dr_ledger;
  //           } else if (isSales) {
  //             const match = service_maps.find((m: any) =>
  //               (m.voucher_type === 'Sales' ||
  //                 salesOrders.some((so: any) => so.section_id === m.section_id)) &&
  //               m.cr_ledger
  //             );
  //             return match?.cr_ledger;
  //           }
  //         }

  //         return undefined;
  //       }).filter((id): id is number => id !== undefined)
  //     )
  //   );

  //   return uniqueIds.map((ledgerId: number) => {
  //     const matchingDetail = details.find((detail: any) => {
  //       const sku_maps = detail?.sku?.sku_detail_maps || [];
  //       const service_maps = detail?.service?.service_ledgr_map || [];

  //       if (detail?.item_service_type === 'SKU') {
  //         if (isPurchase) {
  //           return sku_maps.some((m: any) =>
  //             (m.voucher_type === 'Purchase' ||
  //               purchaseOrders.some((po: any) => po.section_id === m.section_id)) &&
  //             m.dr_ledger === ledgerId
  //           );
  //         } else if (isSales) {
  //           return sku_maps.some((m: any) =>
  //             (m.voucher_type === 'Sales' ||
  //               salesOrders.some((so: any) => so.section_id === m.section_id)) &&
  //             m.cr_ledger === ledgerId
  //           );
  //         }
  //       }

  //       if (detail?.item_service_type === 'Service') {
  //         if (isPurchase) {
  //           return service_maps.some((m: any) =>
  //             (m.voucher_type === 'Purchase' ||
  //               purchaseOrders.some((po: any) => po.section_id === m.section_id)) &&
  //             m.dr_ledger === ledgerId
  //           );
  //         } else if (isSales) {
  //           return service_maps.some((m: any) =>
  //             (m.voucher_type === 'Sales' ||
  //               salesOrders.some((so: any) => so.section_id === m.section_id)) &&
  //             m.cr_ledger === ledgerId
  //           );
  //         }
  //       }

  //       return false;
  //     });

  //     let ledgerName: string | undefined;

  //     if (matchingDetail) {
  //       const sku_maps = matchingDetail?.sku?.sku_detail_maps || [];
  //       const service_maps = matchingDetail?.service?.service_ledgr_map || [];

  //       if (matchingDetail?.item_service_type === 'SKU') {
  //         if (isPurchase) {
  //           ledgerName = sku_maps.find((m: any) =>
  //             (m.voucher_type === 'Purchase' ||
  //               purchaseOrders.some((po: any) => po.section_id === m.section_id)) &&
  //             m.dr_ledger === ledgerId
  //           )?.dr_ledger_name;
  //         } else if (isSales) {
  //           ledgerName = sku_maps.find((m: any) =>
  //             (m.voucher_type === 'Sales' ||
  //               salesOrders.some((so: any) => so.section_id === m.section_id)) &&
  //             m.cr_ledger === ledgerId
  //           )?.cr_ledger_name;
  //         }
  //       } else if (matchingDetail?.item_service_type === 'Service') {
  //         if (isPurchase) {
  //           ledgerName = service_maps.find((m: any) =>
  //             (m.voucher_type === 'Purchase' ||
  //               purchaseOrders.some((po: any) => po.section_id === m.section_id)) &&
  //             m.dr_ledger === ledgerId
  //           )?.dr_ledger_name;
  //         } else if (isSales) {
  //           ledgerName = service_maps.find((m: any) =>
  //             (m.voucher_type === 'Sales' ||
  //               salesOrders.some((so: any) => so.section_id === m.section_id)) &&
  //             m.cr_ledger === ledgerId
  //           )?.cr_ledger_name;
  //         }
  //       }
  //     }

  //     const totalDiscountedAmount = this.getSumByLedgerId2(ledgerId);

  //     return {
  //       ledger_id: ledgerId,
  //       ledger_name: ledgerName,
  //       totalDiscountedAmount
  //     };
  //   });
  // }
  
  uniqueLedgerIds2() {

  const details = this.data?.productList?.flatMap((p: any) => p.details || []) || [];

  const isPurchase = this.data?.grn?.length !== 0 && this.data?.voucher === 'Purchase';
  const isSales = this.data?.voucher === 'Sales';

  const ledgerMap = new Map<number, any>();

  details.forEach((detail: any) => {
    const sectionIds = detail?.section_id
      ? detail.section_id.toString().split(',').map(Number)
      : [];

    const maps = detail?.item_service_type === 'SKU'
      ? detail?.sku?.sku_detail_maps || [] 
      : detail?.item_service_type === 'Service'
      ? detail?.service?.service_ledgr_map || [] 
      : detail?.item_service_type === 'Fixed Asset'
      ? detail?.fa_master || []
      : [];

    maps.forEach((m: any) => {
      // const isSectionMatch = sectionIds.includes(Number(m.section_id));
      const isFixedAsset = detail?.item_service_type === 'Fixed Asset';
      const isSectionMatch = isFixedAsset ? true : sectionIds.includes(Number(m.section_id));

      if (!isSectionMatch) return;

      // ================= FIXED ASSET =================
      if (isFixedAsset) {
        if (isPurchase && m.ledger_id) {
          if (!ledgerMap.has(m.ledger_id)) {
            ledgerMap.set(m.ledger_id, {
              ledger_id: m.ledger_id,
              ledger_name: m.ledger?.ledger_name || 'NA'
            });
          }
        }
        return; // Fixed asset only handles purchase case here
      }

      // ================= PURCHASE (SKU/Service) =================
      if (isPurchase && m.dr_ledger) {
        if (!ledgerMap.has(m.dr_ledger)) {
          ledgerMap.set(m.dr_ledger, {
            ledger_id: m.dr_ledger,
            ledger_name: m.dr_ledger_name
          });
        }
      }

      // ================= SALES (SKU/Service) =================
      if (isSales && m.cr_ledger) {
        if (!ledgerMap.has(m.cr_ledger)) {
          ledgerMap.set(m.cr_ledger, {
            ledger_id: m.cr_ledger,
            ledger_name: m.cr_ledger_name
          });
        }
      }

    });

  });

  // 👉 Add total
  return Array.from(ledgerMap.values()).map((ledger: any) => ({
    ...ledger,
    totalDiscountedAmount: this.getSumByLedgerId2(ledger.ledger_id)
  }));
}
  getGstLedgerDetails2(taxType: number): { gst_percentage: number } {
    const gstLedger = this.data.taxledger.find(item => item?.global_gst_id === taxType)
    if (gstLedger) {
      return {
        gst_percentage: gstLedger.gst_percentage
      };
    } else {
      return { gst_percentage: 0 };
    }
  }
  getGroupedGstLedgers() {
    const groupedLedgers: Record<number, { gstType: string; ledgerName: string; gstAmount: number; gstId: number }[]> = {};

    for (const product of this.data.productList) {
      for (const detail of product.details) {
        const gstAmount = this.calculateGstAmount2(detail);
        const gstId = detail.hsn_sac?.gst_id || 0;

        if (!gstId) continue;

        const taxEntry = this.data.taxledger.find(t => t?.global_gst_id === gstId);
        if (!taxEntry) continue;

        const requiredLedgerType = this.data.voucher === "Purchase" ? "receivable" : "payable";

        for (const gstLedger of taxEntry.gst_ledgers) {
           if (this.data.gstMatch) {
          // Same state → allow CGST & SGST only
          if (gstLedger.gst_type !== "CGST" && gstLedger.gst_type !== "SGST") continue;
        } else {
          // Different state → allow IGST only
          if (gstLedger.gst_type !== "IGST") continue;
        }

          // const isCorrectType = (gstLedger.gst_type === "CGST" || gstLedger.gst_type === "SGST" || gstLedger.gst_type === "IGST");
          const isCorrectLedger = gstLedger.ledger_type === requiredLedgerType;
          const isCorrectBranch = gstLedger.branch_id === this.data.branch_id;
          if (isCorrectLedger && isCorrectBranch) {
            if (!groupedLedgers[gstId]) groupedLedgers[gstId] = [];

            const alreadyExists = groupedLedgers[gstId].some(
              entry => entry.gstType === gstLedger.gst_type
            );
            if (!alreadyExists) {
              groupedLedgers[gstId].push({
                gstId,
                ledgerName: gstLedger.ledger?.ledger_name ?? 'Unknown Ledger',
                gstType: gstLedger.gst_type,
                gstAmount: this.data.gstMatch ? gstAmount / 2 : gstAmount
              });
            } else {
              const entry = groupedLedgers[gstId].find(
                entry => entry.gstType === gstLedger.gst_type
              );
              if (entry) entry.gstAmount += this.data.gstMatch ? gstAmount / 2 : gstAmount;;
            }
          }
        }
      }
    }

    return Object.values(groupedLedgers).flat();
  }
  
calculateGstAmount2(detail: any): number {
  const discountedPrice = this.data.grn.length !== 0
    ? this.calculateDiscount(detail.receive_qty, detail.unit_price, 0,0)
    : this.calculateDiscount(detail.send_qty, detail.unit_price, detail.discount_amount,detail.incentive_amount);
  const gstDetails = this.getGstLedgerDetails2(detail.hsn_sac?.gst_id || 0);
  const gstPercentage = gstDetails.gst_percentage || 0;
  return (discountedPrice * gstPercentage) / 100;
  }
  // getLedgerName(detail: any, voucher: string): string | null {
  //   const sku_maps = detail?.sku?.sku_detail_maps || [];
  //   const service_maps = detail?.service?.service_ledgr_map || [];
  //   const productList = this.data?.productList || [];
  //   // const purchaseOrders = productList.flatMap(product => product.purchase_order || []);
  //   // const salesOrders = productList.flatMap(product => product.sales_order || []);
  //   const purchaseOrders = productList.flatMap((p: any) =>
  //     (p.details || []).map((d: any) => p.purchase_order).filter(Boolean)
  //   );

  //   const salesOrders = productList.flatMap((p: any) =>
  //     (p.details || []).map((d: any) => p.sales_order).filter(Boolean)
  // );
  //   // const purchaseOrders = productList.map((p: any) => p.purchase_order).filter(Boolean);

  //   // const salesOrders = productList.flatMap((p: any) =>
  //   //   (p.details || [])
  //   //     .filter((d: any) => d.sales_order)
  //   //     .map((d: any) => ({
  //   //       sales_order: d.sales_order,
  //   //       section_id: d.section_id,
  //   //       item_service_type: d.item_service_type
  //   //     }))
  //   // );
  //   if (voucher === 'Purchase') {
  //     if (detail?.item_service_type === 'SKU') {
  //     for (const po of purchaseOrders) {
  //       const match = sku_maps.find((m: any) =>
  //         m.voucher_type === 'Purchase' || m.section_id === po.section_id
  //       );
  //       if (match?.dr_ledger_name) {
  //         return match.dr_ledger_name;
  //       }
  //     }
  //     } else {
  //       for (const po of purchaseOrders) {
  //       const match = service_maps.find((m: any) =>
  //         m.voucher_type === 'Purchase' || m.section_id === po.section_id
  //       );
  //       if (match?.dr_ledger_name) {
  //         return match.dr_ledger_name;
  //       }
  //     }
  //     }
  //   }
  
  //   if (voucher === 'Sales') {
  //     if (detail?.item_service_type === 'SKU') {
  //       for (const so of salesOrders) {
  //         // const match = sku_maps.find((m: any) =>
  //         //   m.voucher_type === 'Sales' && m.section_id == so.section_id
  //         // );
  //         const soSectionIds = so.section_id?.toString().split(',').map(Number);

  //         const match = sku_maps.filter((sku: any) =>
  //           soSectionIds.includes(Number(sku.section_id)) &&
  //           Number(sku.voucher_id) === Number(this.data.voucher_id)
  //         );

  //         console.log('match1',match);
  //         if (match?.cr_ledger_name) {
  //           // return match.cr_ledger_name;
  //           return match[0].cr_ledger_name;
  //         }
  //       }
  //     } else {
  //       for (const so of salesOrders) {
  //         // const match = service_maps.find((m: any) =>
  //         //   m.voucher_type === 'Sales' && m.section_id == so.section_id
  //         // );
  //         const soSectionIds = so.section_id?.toString().split(',').map(Number);

  //         const match = service_maps.filter((service: any) =>
  //           soSectionIds.includes(Number(service.section_id)) &&
  //           Number(service.voucher_id) === Number(this.data.voucher_id)
  //         );
  //         console.log('match2',match);
  //         if (match?.cr_ledger_name) {
  //           return match.cr_ledger_name;
  //         } 
  //       }
  //     }
  //   }
  
  //   return 'NA'; // fallback if nothing matched
  // }
  getLedgerName(detail: any, voucher: string): string {

    const sku_maps = detail?.sku?.sku_detail_maps || [];
    const service_maps = detail?.service?.service_ledgr_map || [];
    const fa_maps = detail?.fa_master || [];
    const sectionIds = detail?.section_id
      ? detail.section_id.toString().split(',').map(Number)
      : [];
    let filtered: any[] = [];
    if (voucher === 'Purchase') {
      if (detail?.item_service_type === 'SKU' || detail?.item_service_type === 'Service') {
        const maps = detail?.item_service_type === 'SKU' ? sku_maps : service_maps;
        filtered = maps.filter((m: any) =>
          sectionIds.includes(Number(m.section_id)) &&
          Number(m.voucher_id) === Number(this.data.voucher_id)
        );
      }
      else if (detail?.item_service_type === 'Fixed Asset') {
        filtered = fa_maps
      }
      return filtered.length
        ? (detail?.item_service_type === 'Fixed Asset'
          ? filtered[0]?.ledger?.ledger_name
          : filtered[0]?.dr_ledger_name)
        : 'NA';
    }
    if (voucher === 'Sales') {
      const maps = detail?.item_service_type === 'SKU' ? sku_maps : service_maps;

      const match = maps.find((m: any) =>
        sectionIds.includes(Number(m.section_id)) &&
        Number(m.voucher_id) === Number(this.data.voucher_id)
      );
      return match?.cr_ledger_name || 'NA';
    }
    return 'NA';
  }
  getLedgerNameForProduct(product: any): string {
    const voucher = this.data.voucher;
    const type = product.productType?.type;
    let match;
  
    if (voucher === 'Purchase' && type === 'SKU') {
      match = product.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Purchase');
      return match?.dr_ledger_name ?? 'No Purchase Sku ledger found';
    } else if (voucher === 'Purchase' && type === 'Service') {
      match = product.productType?.service_ledgr_map?.[0];
      return match?.ledger?.ledger_name ?? 'No Purchase Service Ledger found';
    } else if (voucher === 'Sales' && type === 'SKU') {
      match = product.productType?.sku_detail_maps?.find((map: any) => map.voucher_type === 'Sales');
      return match?.cr_ledger_name ?? 'No Sales Sku ledger found';
    } else if (voucher === 'Sales' && type === 'Service') {
      match = product.productType?.service_ledgr_map?.[0];
      return match?.ledger?.ledger_name ?? 'No Sales Service Ledger found';
    }
  
    return 'No ledger found';
  } 
}  